import {loadRentContractData} from "../../../rent_contracts/actions.js";

export const initialize = () => async (dispatch) => {
  await dispatch(loadRentContractData({
    reservationPath: "B2B"
  }));
};
